import {get$} from '../lib/utils'
import ScrollMixins from './scroller'

export default {
  mixins: [ScrollMixins],
  data() {
    return {
      formSubmitting: false,
      formReadyForSubmit: false,
    }
  },
  computed: {
    isAnyInvalid() {
      return this.$v.$invalid
    }
  },
  methods: {
    findAnyInvalid() {
      return this.$v.$invalid
    },
    getFirstValidationError() {
      return get$('.form-group.is-invalid')
    },
    scrollToFirstErrorElement() {
      this.$nextTick(() => {
        const elm = this.getFirstValidationError()
        if (elm) {
          this.scrollTo(elm)
        }
      })
    },
    submittingInvalid(fieldName) {
      return this.formSubmitting && this.dirtyInvalid(fieldName)
    },
    submittingInvalidRule(fieldName, rule) {
      return this.formSubmitting && this.dirtyInvalidRule(fieldName, rule)
    },
    invalidGroup(group) {
      return _.get(this.$v, group + '.$invalid')
    },
    dirty(fieldName) {
      return _.get(this.$v, fieldName + '.$dirty')
    },
    invalid(fieldName) {
      return _.get(this.$v, fieldName + '.$invalid')
    },
    dirtyInvalid(fieldName) {
      return this.dirty(fieldName) && this.invalid(fieldName)
    },
    invalidRule(fieldName, rule) {
      return !_.get(this.$v, fieldName + '.' + rule)
    },
    dirtyInvalidRule(fieldName, rule) {
      return this.dirty(fieldName) && this.invalidRule(fieldName, rule)
    },
    anyInvalids(fieldNames) {
      const fieldsNameList = fieldNames || Object.keys(this.fields || {})
      return _.some(fieldsNameList, fieldName => this.invalid(fieldName)) || false
    }
  }
}
